
export default function About() {
  const differentiators = [
    'Industry-leading placement success rate',
    'Dedicated account management team',
    'Comprehensive candidate screening process',
    'Flexible engagement models',
    'Global talent network access'
  ];

  return (
    <section id="about" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 font-semibold rounded-full mb-6">
              About Our Company
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Your Trusted Recruitment Partner Since 2023
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              Under the visionary leadership of Managing Director Sachin Dubey and Director Sonam Dubey, we have established ourselves as a dynamic recruitment consultancy trusted by leading companies and innovative startups alike. Our mission is to create meaningful connections between exceptional talent and forward-thinking organizations.
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Our team of experienced recruitment specialists combines deep industry knowledge with cutting-edge technology to deliver unparalleled results. We don't just fill positions – we build lasting partnerships that drive organizational success and career growth.
            </p>
            
            <div className="space-y-3 mb-8">
              {differentiators.map((item, index) => (
                <div key={index} className="flex items-center">
                  <div className="w-6 h-6 flex items-center justify-center bg-teal-600 rounded-full mr-3 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>
            
            <a
              href="#contact"
              className="inline-flex items-center px-6 py-3 border-2 border-teal-600 text-teal-600 font-semibold rounded-lg hover:bg-teal-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Our Story
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20professional%20recruitment%20team%20collaborating%20in%20modern%20bright%20office%20space%20with%20laptops%20and%20documents%20showing%20teamwork%20and%20expertise%20in%20contemporary%20corporate%20environment%20with%20natural%20lighting&width=800&height=900&seq=about-team-001&orientation=portrait"
                alt="Our Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className="ri-award-line text-3xl text-teal-600"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">Since 2023</div>
                  <div className="text-sm text-gray-600">Excellence in Recruitment</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
